import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  contentHeight100,
  contentStyle,
  contentStyle150,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import EqHis from '../../models/data/EqHis';
import dateRange, { dateformat } from '../date-range';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: EqHis | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={1}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* ID */}
      <Descriptions
        bordered
        column={3}
        contentStyle={contentStyle150}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqMaintDetail }}
      >
        <Descriptions.Item label="設備点検ID" span={1}>
          {data?.eqWorkHisId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="顧客設備ID" span={1}>
          {data?.custEqId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="登録日" span={1}>
          {dateformat(data?.inputDate)}
        </Descriptions.Item>
      </Descriptions>
      {/* 点検履歴詳細 */}
      <Descriptions
        bordered
        column={2}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.eqMaintDetail }}
      >
        <Descriptions.Item label="作業名" span={2}>
          {data?.workName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="工号" span={2}>
          {data?.jobNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="点検種別" span={2}>
          {data?.workType ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="点検年月日" span={2}>
          {dateRange(data?.workSYmd, data?.workEYmd)}
        </Descriptions.Item>
        <Descriptions.Item label="更新日" span={2}>
          {dateformat(data?.revDate)}
        </Descriptions.Item>
        <Descriptions.Item
          label="点検内容"
          span={2}
          contentStyle={{ ...contentStyle, ...contentHeight100 }}
        >
          {data?.eqWorkHisSummary ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="使用部品" span={2}>
          {data?.eqWorkHisUseParts ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="作業員名" span={2}>
          {data?.eqWorkHisStaffName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="作業結果" span={2}>
          {data?.eqWorkHisResultComp ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="備考" span={2}>
          {data?.eqWorkHisBiko ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="報告書番号" span={2}>
          {data?.reportNo ?? ''}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
